import React from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, object, func, string } from 'prop-types'

import CartItemsList from 'Pods/UnifiedNavigation/Shared/CartItemsList/CartItemsList'
import EmptyContent from 'Pods/UnifiedNavigation/Shared/EmptyContent/EmptyContent'

function RecentItems({
  recentItems,
  isRecentLoading,
  isRecentErrored,
  fetchData,
  isCartBelowThreshold,
  isCartAboveThreshold,
  shouldShowCartProgress,
  trackAddToCart,
  locale = 'en',
}) {
  function handleAddToCartTrack(id, index) {
    const matchingItem = recentItems.meta.trackingRecentItems.find((item) => item.itemId === id)

    trackAddToCart({
      ...matchingItem,
      source: 'cart-recent',
      index,
    })
  }

  if (recentItems.data.length === 0 && isRecentLoading) {
    return (
      <div className="row justify-content-center cgt-mt-16 cgt-mr-10 cgt-ml-10 cgt-mb-10">
        <Spinner size="small" />
      </div>
    )
  }

  if (recentItems.meta && recentItems.meta.totalCount) {
    return (
      <div className="popover__cart cgt-mt-16">
        <CartItemsList
          items={recentItems.data}
          included={recentItems.included}
          onLoadNextPage={() => fetchData(recentItems.page + 1)}
          hasError={isRecentErrored}
          isLastPageLoaded={recentItems.isLastPageLoaded}
          trackCartRemoveGA4={() => {}}
          trackAddToCart={handleAddToCartTrack}
          isCartBelowThreshold={isCartBelowThreshold}
          isCartAboveThreshold={isCartAboveThreshold}
          shouldShowCartProgress={shouldShowCartProgress}
          actionType="add"
          listType="cart-recent"
          useIncludedData={false}
        />
      </div>
    )
  }

  return (
    <div>
      <EmptyContent variation="recently-viewed-tab" locale={locale} />
    </div>
  )
}

RecentItems.propTypes = {
  recentItems: object.isRequired,
  isRecentLoading: bool.isRequired,
  isRecentErrored: bool.isRequired,
  fetchData: func.isRequired,
  isCartBelowThreshold: bool.isRequired,
  isCartAboveThreshold: bool.isRequired,
  shouldShowCartProgress: bool.isRequired,
  trackAddToCart: func.isRequired,
  locale: string,
}

export default RecentItems
